module.exports = __webpack_public_path__ + "static/media/C10.77f18c36.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/C10.png
// module id = 892
// module chunks = 0